import { render } from "./UEElectricityListView.vue?vue&type=template&id=b6ba05a2&scoped=true"
import script from "./UEElectricityListView.vue?vue&type=script&lang=js"
export * from "./UEElectricityListView.vue?vue&type=script&lang=js"

import "./UEElectricityListView.vue?vue&type=style&index=0&id=b6ba05a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ba05a2"]])

export default __exports__